import React from "react";
import { useTableResponsive } from "../../../hooks/useTableResponsive";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import PdfZipItem from "../../../components/PdfZipItem";

const NoticeTab = ({ data, title }) => {
  const { getText } = useLanguageTranslation();
  useTableResponsive(data);
  return (
    <>
      <div className=" wow zoomIn">
        <h2 className="title4">{title}</h2>
        <table className="table table-striped custom-table">
          <thead>
            <tr>
              <th>{getText("S.No.", "क्र. सं.")}</th>
              <th>{getText("Description", "विवरण")}</th>
              <th>{getText("Download", "डाउनलोड")}</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td data-key={getText("S.No.", "क्र. सं.")}>{index + 1}</td>
                <td data-key={getText("Description", "विवरण")}>{item.title}</td>
                <td data-key={getText("Download", "डाउनलोड")}>
                  <PdfZipItem
                    filePath={item?.field_download}
                    filesize={item?.filesize}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default NoticeTab;
